import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a7b9818"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui-pedido-acompanhamento-page" }
const _hoisted_2 = { class: "ui-forca-vendas-pedido-acompanhamento" }
const _hoisted_3 = { class: "ui-mobile-toolbar" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ui-toolbar-title" }, " Pedidos ", -1))
const _hoisted_5 = { class: "ui-toolbar-actions" }
const _hoisted_6 = { class: "ui-mobile-content" }
const _hoisted_7 = { class: "ui-filtros-card" }
const _hoisted_8 = { class: "ui-filtro-periodo" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Período:", -1))
const _hoisted_10 = {
  style: {"display":"none"},
  class: "ui-filtro-pesquisa"
}
const _hoisted_11 = { class: "ui-resumo-pedidos" }
const _hoisted_12 = { class: "ui-resumo-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Pedidos", -1))
const _hoisted_14 = { class: "ui-resumo-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Itens", -1))
const _hoisted_16 = { class: "ui-resumo-item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total", -1))
const _hoisted_18 = { class: "ui-lista-pedidos" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "ui-pedido-dados" }
const _hoisted_21 = { class: "ui-cliente-nome ui-ellipsis" }
const _hoisted_22 = { class: "ui-cliente-documento" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "CPF/CNPJ:", -1))
const _hoisted_24 = { class: "ui-pedido-grid" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "No. PEDIDO:", -1))
const _hoisted_26 = { class: "ui-pedido-numero" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Emissão:", -1))
const _hoisted_28 = { class: "ui-pedido-grid" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Pedido ERP:", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Status:", -1))
const _hoisted_31 = { class: "ui-pedido-grid" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Qtde Itens:", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Valor:", -1))
const _hoisted_34 = { class: "ui-forma-pagamento" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_selecionar_data_inicial_final = _resolveComponent("selecionar-data-inicial-final")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_comunicacao_api = _resolveComponent("comunicacao-api")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "ui-toolbar-btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.voltarTela && _ctx.voltarTela(...args)))
        }, " ‹ "),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            type: "button",
            class: "ui-toolbar-btn",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.buscarPedidos && _ctx.buscarPedidos(...args)))
          }, " ↻ ")
        ])
      ]),
      _createVNode(_component_a_skeleton, {
        loading: _ctx.appBase.carregando
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_selecionar_data_inicial_final, {
                  style: {"max-width":"230px"},
                  "data-inicial-selecionada": _ctx.state.filtros.dataInicial,
                  "data-final-selecionada": _ctx.state.filtros.dataFinal,
                  "onUpdate:dataFinalSelecionada": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.filtros.dataFinal) = $event)),
                  onChange: _ctx.buscarPedidos
                }, null, 8, ["data-inicial-selecionada", "data-final-selecionada", "onChange"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.pesquisa) = $event)),
                  type: "text",
                  class: "ant-input",
                  placeholder: "Pesquisar por cliente, CPF/CNPJ, pedido, ERP ou status"
                }, null, 512), [
                  [_vModelText, _ctx.state.pesquisa]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("strong", null, _toDisplayString(_ctx.pedidosFiltrados.length), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("strong", null, _toDisplayString(_ctx.quantidadeItensPedidos), 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("strong", null, _toDisplayString(_ctx.formatarMoeda(_ctx.valorTotalPedidos)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              (!_ctx.UtilitarioGeral.validaLista(_ctx.pedidosFiltrados))
                ? (_openBlock(), _createBlock(_component_a_empty, {
                    key: 0,
                    description: "Nenhum pedido encontrado"
                  }))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pedidosFiltrados, (pedido, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: pedido.codigo,
                  class: "ui-pedido-card",
                  onClick: ($event: any) => (_ctx.abrirPedido(pedido))
                }, [
                  _createElementVNode("div", {
                    class: "ui-status-barra",
                    style: _normalizeStyle('background-color:' + _ctx.servicoPedido.obterCorStatus(pedido.status) + ';')
                  }, [
                    _createElementVNode("span", null, _toDisplayString(index + 1), 1)
                  ], 4),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, _toDisplayString(pedido.nomeRazaoSocial), 1),
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _createElementVNode("span", null, _toDisplayString(_ctx.UtilitarioMascara.mascararCPFOuCNPJ(pedido.cpfCnpj)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", null, [
                        _hoisted_25,
                        _createElementVNode("span", _hoisted_26, _toDisplayString(pedido.numeroIdentificacao), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_27,
                        _createElementVNode("span", null, _toDisplayString(_ctx.formatarData(pedido.data)), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", null, [
                        _hoisted_29,
                        _createElementVNode("span", null, _toDisplayString(pedido.numeroErp || '-'), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_30,
                        _createElementVNode("span", null, _toDisplayString(_ctx.servicoPedido.obterDescricaoStatus(pedido.status)), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", null, [
                        _hoisted_32,
                        _createElementVNode("span", null, _toDisplayString(_ctx.obterQuantidadeItens(pedido)), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_33,
                        _createElementVNode("span", null, _toDisplayString(_ctx.formatarMoeda(pedido.valorTotal)), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, _toDisplayString(pedido.detalhesFormaPagamento || 'DINHEIRO'), 1)
                  ])
                ], 8, _hoisted_19))
              }), 128))
            ])
          ])
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _createVNode(_component_comunicacao_api, {
      visivel: _ctx.appBase.exibirComunicaoApi,
      "onUpdate:visivel": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.appBase.exibirComunicaoApi) = $event)),
      apresentarBarraProgresso: _ctx.appBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.appBase.fraseBarraProgresso,
      resposta: _ctx.appBase.resposta
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "resposta"])
  ]))
}